import React, { useState, useEffect } from 'react';
import './MenuPermissions.css';
import TextDisplay from '../../../Forms/TextDisplay/TextDisplay';
import ArcToggle from '../../../Forms/ArcToggle/ArcToggle';

const MenuPermissions = (props) => {

    useEffect(() => {

        var id = props.data.length !== 0 ? props.data[0].Key : "";
        if (id !== undefined && id !== null) {
            let doc = document.getElementById(id);
            if (doc !== undefined && doc !== null) {
                doc.focus();
            }
        }
    
    }, []);

    const data = props.data;

    const valueChangeHandler = (id, value) => {
        const itemToChange = data.filter((item) => item.Key === id)[0];
        itemToChange.Allowed = value;

        const returnValue = {
            Allowed: value,
            Key: id,
            Name: itemToChange.Name,
        };
        props.changeHandler(id, returnValue);
    };

    return (
        <div className="app-crafted-content">
            <div className="app-crafted-title">{props.config.PageTitle}</div>
            <div className="app-crafted-headertext">
                <TextDisplay text={props.config.Text}></TextDisplay>
            </div>
            <div className="menupermissions-content">
                {props.data.map((item, index) => {
                    const config = {
                        Label: item.Name,
                        value: item.Allowed,
                        id: item.Key,
                    };
                    return (
                        <div key={index} className="menupermissions-item">
                            <ArcToggle
                                config={config}
                                valueChangeHandler={valueChangeHandler}
                                showText={false}
                                onKeyDown={props.onKeyDown}
                            ></ArcToggle>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MenuPermissions;
